import api from './api';

export const subscriptionService = {
  getSubscription: async () => {
    const response = await api.get('/shops/subscription');
    return response.data;
  },

  getConfig: async () => {
    const response = await api.get('/subscription/config');
    return response.data;
  },

  requestPayment: async (data = {}) => {
    const response = await api.post('/shops/subscription/request-payment', data);
    return response.data;
  },
};

export default subscriptionService;
